// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"16":"votacion","109":"altares","602":"votable","754":"jornada-artistas","907":"cdi","918":"literature"}[chunkId] || chunkId) + "." + {"16":"027b983e","109":"6301c114","483":"d288a3a0","602":"5ea717dc","754":"a2b963c6","773":"38a6ac42","907":"3cc82cd7","918":"323033c4"}[chunkId] + ".js";
};